import { Icon } from "@/components/ui/Icon";
import { qty } from "@/lib/format";
import { STATUS_LABELS } from "@/lib/labels";
import "./dashboard.css";

/**
 * Topshiriq turlari — rangli bloklar.
 *
 * Nega jadval emas: dispetcher bu yerdan BITTA narsani qidiradi —
 * qaysi turda ish to'planib qolgan. Jadvalda u sakkizta qatorning
 * to'rtta ustunini ko'z bilan taqqoslashi kerak edi; blokda esa
 * katta son o'zi ko'rinadi va rang turni o'qimasdan topish
 * imkonini beradi.
 *
 * Rang TURNI bildiradi, holatni emas: holat ranglari (qizil —
 * xato, sariq — ogohlantirish) panelning qolgan qismida boshqa
 * ma'noga ega va ularni bu yerda takrorlash chalkashtirardi.
 */

export interface TypeRow {
  task_type: string;
  queued: number;
  held: number;
  stalled: number;
  completed: number;
  /** Ochiq topshiriqlardagi satrlar soni — «SKU». */
  openLines: number;
  /** Ochiq topshiriqlardagi reja miqdori. */
  openQty: string;
  /** Davrda yakunlanganlarning FAKT miqdori. */
  doneQty: string;
}

export function TaskTypes({ rows, loading }: { rows: TypeRow[]; loading?: boolean }) {
  if (loading) {
    return (
      <div className="type-grid">
        {[0, 1, 2, 3].map((index) => (
          <div className="skeleton" style={{ height: 132 }} key={index} />
        ))}
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <p className="field-hint" style={{ margin: 0 }}>
        Topshiriq yo'q — bu davrda yaratilmagan va ochiq topshiriq ham yo'q.
      </p>
    );
  }

  return (
    <div className="type-grid">
      {rows.map((row) => {
        const open = row.queued + row.held + row.stalled;

        return (
          <article className="type-tile" data-type={row.task_type} key={row.task_type}>
            <div className="type-head">
              <span className="type-name" title={row.task_type}>
                {STATUS_LABELS[row.task_type] ?? row.task_type}
              </span>
              {/* To'xtagan ish BELGI bilan: u o'z-o'zidan
                  harakatlanmaydi va aralashuv talab qiladi. */}
              {row.stalled > 0 && (
                <span className="type-flag" title={`${row.stalled} ta to'xtab turibdi`}>
                  <Icon name="alert" size={12} />
                  {row.stalled}
                </span>
              )}
            </div>

            {/* Son va izoh BITTA qatorda: blok past bo'lsa,
                podium birinchi ekranga sig'adi. */}
            <div className="type-open">
              <span className={`num${open === 0 ? " dash-zero" : ""}`}>{open}</span>
              <span className="type-unit">ochiq</span>
            </div>

            {/* Ochiqning ichki taqsimoti: «navbatda» dispetcherga
                ish beradi, «jarayonda» esa allaqachon biriktirilgan. */}
            <div className="type-bar" aria-hidden="true">
              <span className="type-bar-queued" style={{ flexGrow: row.queued }} />
              <span className="type-bar-held" style={{ flexGrow: row.held }} />
              <span className="type-bar-stalled" style={{ flexGrow: row.stalled }} />
            </div>

            <div className="type-split">
              <span>{row.queued} navbatda</span>
              <span>{row.held} jarayonda</span>
            </div>

            {/* Ochiq ishning HAJMI: topshiriq soni qancha ish
                borligini aytmaydi — bitta topshiriqda bitta ham,
                ellikta ham tovar bo'lishi mumkin. */}
            <div className="type-volume">
              {row.openLines} SKU · {qty(row.openQty)} dona
            </div>

            <div className="type-done">
              {row.completed > 0
                ? `${row.completed} bajarildi · ${qty(row.doneQty)} dona`
                : "bajarilgani yo'q"}
            </div>
          </article>
        );
      })}
    </div>
  );
}
